<ng-container [ngSwitch]="version$ | async" *ngIf="resourcesMap$|async; else loading">
  <gen-treatment-view
    *ngSwitchCase="2"
    [workflowId]="workflowId"
    [revisionId]="revisionId"
    [isPerformer]="performerLevel === assigneeLevel"
    [resourcesMap$]="resourcesMap$"
  ></gen-treatment-view>
  <gen-therapy-prioritize *ngSwitchDefault></gen-therapy-prioritize>
</ng-container>

<ng-template #loading>
  <gen-overlay-loader></gen-overlay-loader>
</ng-template>
